import { createFileRoute } from "@tanstack/react-router";

import { OrganizationSettings } from "@/features/settings";

/**
 * ``/settings/organization`` — self-serve org management for the org's
 * owner/admin (branding · members · SSO).
 *
 * Re-enabled Aug 2026: management is self-serve in BOTH products (console +
 * platform); the finer "who may create paid seats" controls are layered on
 * later. Actions are gated INSIDE ``OrgMembersPanel`` (``isAdmin`` = role
 * owner/admin): a plain member sees a read-only view, owner/admin manage — so
 * the page is safe to expose without a route-level gate.
 *
 * Distinct from ``/admin/orgs`` (operator surface over ALL orgs): same
 * components, different audience/scope, so it is NOT the "two surfaces for the
 * same operation" the Jun-2026 collapse removed (that was operator-vs-operator).
 */
export const Route = createFileRoute("/_authed/_modal/settings/organization")({
  component: OrganizationSettings,
});
